import { render, staticRenderFns } from "./ForgetPw.vue?vue&type=template&id=a9397f6c&scoped=true&"
import script from "./ForgetPw.vue?vue&type=script&lang=js&"
export * from "./ForgetPw.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPw.vue?vue&type=style&index=0&id=a9397f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9397f6c",
  null
  
)

export default component.exports